import React, { useState } from "react"
import PageHeading from "components/common/LayoutComponents/PageHeading"
import Tab from "@mui/material/Tab"
import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import Box from "@mui/material/Box"
import LoadingScreen from "components/common/LoadingScreen"

import RailGroupManagement from "./RailGroupManagement/RailGroupManagement"
import RailManagement from "./RailManagement/RailManagement"
import { RailControlPanelWrapper } from "./Rails.style"

const RailControlPanel = () => {
  const [value, setValue] = useState("rail")

  const [railGroupContent, railGroupLoading] = RailGroupManagement()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <RailControlPanelWrapper>
      <PageHeading>
        <div className="heading-copy">
          <h1 className="page-title">Rails Management</h1>
          <p className="page-subtitle">
            Configure rail collections, ordering, and group composition rules.
          </p>
        </div>
        <div className="actions"></div>
      </PageHeading>
      <div className="tabs-shell">
        <TabContext value={value}>
          <Box className="tabs-head">
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Rails" value="rail" />
              <Tab label="Groups" value="group" />
            </TabList>
          </Box>
          <TabPanel className="tab-panel" value="rail">
            <RailManagement />
          </TabPanel>
          <TabPanel className="tab-panel" value="group">
            {railGroupContent}
          </TabPanel>
        </TabContext>
      </div>
      <LoadingScreen loading={railGroupLoading} />
    </RailControlPanelWrapper>
  )
}

export default RailControlPanel
